import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { contactsAPI, contactsEndpoints } from '@/api/contacts';
import { getPermissions } from '@/redux/permissions/selectors';
import type { DebtStatusEvent } from '@/shared/types/contacts';
import { actions } from '@/shared/types/permissions';
import { RootState } from '@/shared/types/state';

const EMPTY_EVENTS: DebtStatusEvent[] = [];

export const useDebtEvents = (debtId: string) => {
  const canRead = useSelector((state: RootState) => getPermissions(state, 'debts', actions.READ));

  const { data, status } = useQuery({
    queryKey: [contactsEndpoints.debtEvents(debtId)],
    queryFn: () => contactsAPI.listDebtEvents(debtId),
    select: (response) => [...response.events].reverse(),
    enabled: canRead,
  });

  return { canRead, events: data ?? EMPTY_EVENTS, status };
};
